import { Stack } from "@chakra-ui/react";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import ProgressItem from "../../components/items/ProgressItem";
import useGetLearningPathProgresses from "../../hooks/api/learning-path/useGetLearningPathProgresses";
import { Lesson } from "../../models/Lesson";
import BasePage from "../common/BasePage";
import { useTranslation } from "react-i18next";
import ExamProgressLegend from "../../components/ExamProgressLegend";

type Params = {
  learningPathId: string;
};

export default function ProgressesPage() {
  const { t } = useTranslation();
  const { learningPathId } = useParams<Params>();
  const {
    data: learningPath,
    isLoading,
    isError,
    refetch,
  } = useGetLearningPathProgresses(learningPathId ?? "");

  const lessonsCluster = useMemo(
    () =>
      learningPath?.lessons.reduce<{ [key: string]: Lesson[] }>((p, c) => {
        p[c.module.name] = p[c.module.name] ? [...p[c.module.name], c] : [c];
        return p;
      }, {}) ?? {},
    [learningPath?.lessons],
  );

  return (
    <BasePage
      title={`${t("progresses_page.progresses")} - ${learningPath?.name ?? ""}`}
      isLoading={isLoading}
      hasError={isError}
      retry={refetch}
    >
      <Stack spacing={[8]}>
        {Object.entries(lessonsCluster).map(([clusterName, lessonCluster]) => (
          <ProgressItem
            key={clusterName}
            name={clusterName}
            lessons={lessonCluster}
          />
        ))}
      </Stack>
      <Stack alignItems="flex-end">
        <ExamProgressLegend />
      </Stack>
    </BasePage>
  );
}
